import * as yup from 'yup';
import { MODULES_IDS } from '../../components/Constants';

export const TareaColumnList = (isAdmin) => {
   return [
      {
         id: 'tarea_id',
         dbname: 'id',
         label: 'id',
         visible: false,
         form: false,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'tarea_conjunto_id',
         dbname: 'conjunto_id',
         label: 'conjunto_id',
         visible: !!isAdmin,
         form: !!isAdmin,
         filter: !!isAdmin,
         foreign: {
            table: 'conjunto',
            label: 'conjunto',
            dbname: 'conjuntodesc',
            type: 'large'
         }
      },
      {
         id: 'tarea_nombre',
         dbname: 'nombre',
         label: 'nombre',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'tarea_descripcion',
         dbname: 'descripcion',
         label: 'descripcion',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
      },
      {
         id: 'tarea_fecha_ultima',
         dbname: 'fecha_ultima',
         label: 'fecha_ultima',
         visible: true,
         form: true,
         filter: true,
         type: 'datetime',
      },
      {
         id: 'tarea_dias_proximo',
         dbname: 'dias_proximo',
         label: 'dias_proximo',
         visible: true,
         form: true,
         filter: true,
         type: 'number',
      },
      {
         id: 'tarea_dias_alerta',
         dbname: 'dias_alerta',
         label: 'dias_alerta',
         visible: true,
         form: true,
         filter: true,
         type: 'number',
      },
      {
         id: 'tarea_tipo_estado_id',
         dbname: 'tipo_estado_id',
         label: 'tipo_estado_id',
         visible: true,
         form: true,
         filter: true,
         foreign: {
            table: 'tipo_estado',
            label: 'tipo_estado',
            dbname: 'tipo_estadodesc',
            type: 'small',
            filters: { modulo_id: MODULES_IDS.TAREAS }
         }
      },

   ];
};

export const TareaValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      conjunto_id: yup.number().required(t("not_emtpy_field")),
      nombre: yup.string().required(t("not_emtpy_field")),
      descripcion: yup.string().nullable(),
      fecha_ultima: yup.date().nullable(),
      dias_proximo: yup.number().nullable(),
      dias_alerta: yup.number().nullable(),
      tipo_estado_id: yup.number().nullable(),

   });
};

export const TareaFilterValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      conjunto_id: yup.number().nullable(),
      nombre: yup.string().nullable(),
      descripcion: yup.string().nullable(),
      fecha_ultima: yup.date().nullable(),
      dias_proximo: yup.number().nullable(),
      dias_alerta: yup.number().nullable(),
      tipo_estado_id: yup.number().nullable(),

   });
};